
export const Utils = {
  slugify: function(string) {
    const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
    const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
    const p = new RegExp(a.split('').join('|'), 'g')
    return string.toString().toLowerCase()
      .replace(/\s+/g, '-') // Replace spaces with -
      .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
      .replace(/&/g, '-and-') // Replace & with 'and'
      .replace(/[^\w-]+/g, '') // Remove all non-word characters
      .replace(/-+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, '') // Trim - from end of text
  },
  getUrlParameter: function(name) {
    // eslint-disable-next-line no-useless-escape
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return (results === null) ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  },
  getArrayOfURLParams: function(key,target){
    var values = [];
    if (!target) target = location.href;
    // eslint-disable-next-line no-useless-escape
    key = key.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
    var pattern = key + '=([^&#]+)';
    var o_reg = new RegExp(pattern, 'ig');
    // eslint-disable-next-line no-constant-condition
    while (true) {
      var matches = o_reg.exec(target);
      if (matches && matches[1]){
        values.push(matches[1]);
      } else {
        break;
      }
    }
    if (!values.length){
      return null;
    } else {
      return values.length == 1 ? values[0] : values;
    }
  },
  isInViewport: function(element) {
    const rect = element.getBoundingClientRect()
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    )
  },
};



// WEBPACK FOOTER //
// ./scripts/utils/Utils.js